const statusColors = Object.freeze({
  OPEN: "warning",
  CLOSED: "red",
  RESOLVED: "success",
  REOPENED: "warning",
  ASSIGNED: "processing",
});
const priorityColors = Object.freeze({
  LOW: "green",
  MEDIUM: "blue",
  HIGH: "orange",
  CRITICAL: "red",
});
export { statusColors, priorityColors };
